export default [
    {
        path: '/form-types',
        name: 'FormTypes',
        component: () => import('@/views/Form/FormTypes.vue'),
        meta: { permission: 'form-types.view' }
    },
    {
        path: '/form-types/:id',
        name: 'FormTypeDetail',
        component: () => import('@/views/Form/FormTypeDetail.vue'),
        meta: { permission: 'form-types.view' }
    },
    {
        path: '/forms',
        name: 'Forms',
        component: () => import('@/views/Form/Forms.vue'),
        meta: { permission: 'forms.view' }
    },
    {
        path: '/forms/create/select-type',
        name: 'FormTypeSelect',
        component: () => import('@/views/Form/FormTypeSelect.vue'),
        meta: { permission: 'forms.create' }
    },
    {
        path: '/forms/create',
        redirect: { name: 'FormTypeSelect' }
    },
    {
        path: '/forms/builder',
        name: 'CustomFormBuilder',
        component: () => import('@/views/Form/CustomFormBuilder.vue'),
        meta: { permission: 'forms.create' }
    },
    {
        path: '/forms/:formId/builder',
        name: 'CustomFormBuilderEdit',
        component: () => import('@/views/Form/CustomFormBuilder.vue'),
        meta: { permission: 'forms.update' }
    },
    {
        path: '/forms/:id',
        name: 'Form',
        component: () => import('@/views/Form/Form.vue'),
        meta: { permission: 'forms.view' }
    },
    {
        path: '/forms/:formId/edit',
        name: 'EditForm',
        component: () => import('@/views/Form/CustomFormBuilder.vue'),
        meta: { permission: 'forms.update' }
    },
    {
        path: '/post/create/forms/:id/wizard',
        name: 'FormWizard',
        component: () => import('@/views/Form/FormWizard.vue')
    },
    {
        path: '/forms/:id/app/create',
        name: 'CreateApplications',
        component: () => import('@/views/Form/FormApplications.vue'),
        meta: { permission: 'forms.create' }
    },
    {
        path: '/forms/:id/app/:reference/edit',
        name: 'EditApplications',
        component: () => import('@/views/Form/FormApplications.vue'),
        meta: { permission: 'forms.update' }
    }
]
